import type PointerEventsBoxNone from './types';

const pointerEventsNone: PointerEventsBoxNone = {
    pointerEvents: 'box-none',
};

export default pointerEventsNone;
